import _extends from "@babel/runtime/helpers/extends";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Menu, MenuItem } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { ArrowDownIcon, ArrowUPIcon } from '../../assets/images';
import { MuiStack } from './stackComponent';
import { t } from 'i18next';
var Accordion = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordion, _extends({
    disableGutters: true,
    elevation: 0,
    square: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        borderRadius: '12px'
    };
});
var AccordionSummary = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordionSummary, _extends({
    expandIcon: /*#__PURE__*/ React.createElement(ArrowForwardIosSharpIcon, {
        sx: {
            fontSize: '0.9rem'
        }
    })
}, props)); })(function (_ref2) {
    var theme = _ref2.theme;
    return {
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)'
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1)
        }
    };
});
var AccordionDetails = styled(MuiAccordionDetails)(function (_ref3) {
    var theme = _ref3.theme;
    return {
        padding: theme.spacing(2),
        borderTop: '1px solid rgba(0, 0, 0, .125)'
    };
});
export default function CustomizedAccordions(props) {
    var defaultOpen = props.defaultOpen;
    var _a = React.useState('All'), selectedItem = _a[0], setSelectedItem = _a[1];
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = React.useState(defaultOpen ? defaultOpen : false), accordionOpen = _c[0], setAccordionOpen = _c[1];
    var handleClickFun = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleMenuItemClick = function (item) {
        setSelectedItem(item);
        if (props.onSelectedOption) {
            props.onSelectedOption(item);
        }
        handleClose();
    };
    var onAccordianClick = function (event) {
        setAccordionOpen(!accordionOpen);
        if (props.handleClick && !accordionOpen) {
            props.handleClick();
        }
    };
    return /*#__PURE__*/ React.createElement(Accordion, {
        sx: props.style,
        expanded: accordionOpen
    }, /*#__PURE__*/ React.createElement(AccordionSummary, {
        sx: {
            flexDirection: 'row-reverse'
        },
        expandIcon: /*#__PURE__*/ React.createElement(ArrowForwardIosSharpIcon, {
            sx: {
                fontSize: '0.9rem'
            },
            onClick: onAccordianClick,
            id: props.title
        })
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        alignItems: "center",
        sx: {
            marginLeft: '8px'
        },
        onClick: onAccordianClick
    }, props.isFromServiceHistory && /*#__PURE__*/ React.createElement("img", {
        src: props.icon,
        alt: "icon"
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        sx: {
            paddingLeft: props.isFromServiceHistory ? 2 : 0
        }
    }, props.title)), props.dropdown && /*#__PURE__*/ React.createElement(MuiStack, {
        marginTop: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            color: '#6A7682'
        }
    }, selectedItem), Boolean(anchorEl) ? /*#__PURE__*/ React.createElement("img", {
        style: {
            width: '20px',
            height: '20px',
            marginLeft: '4px'
        },
        alt: "arrow-upi-icon",
        src: ArrowUPIcon,
        onClick: handleClose,
        id: props.title + 'closeImg'
    }) : /*#__PURE__*/ React.createElement("img", {
        style: {
            width: '20px',
            height: '20px',
            marginLeft: '4px'
        },
        alt: "arrow-down-icon",
        src: ArrowDownIcon,
        onClick: handleClickFun,
        id: props.title + 'anchor'
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Menu, {
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: handleClose,
        id: props.title + 'menus'
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        id: props.title + 'menuAll',
        onClick: function () { return handleMenuItemClick('All'); }
    }, t("All")), /*#__PURE__*/ React.createElement(MenuItem, {
        id: props.title + 'menuLabour',
        onClick: function () { return handleMenuItemClick('Labour'); }
    }, t("Labour")), /*#__PURE__*/ React.createElement(MenuItem, {
        id: props.title + 'menuPart',
        onClick: function () { return handleMenuItemClick('Part'); }
    }, t("Part")))))), /*#__PURE__*/ React.createElement(AccordionDetails, null, props.children));
}
